import { IActionPanelAPI } from '@wix/editor-platform-host-integration-apis';
import { IVirtualManifestBuilderProps } from '@wix/editor-platform-manifest-services';
import { Host } from '@wix/sdk';

import { getPlatformInfraAPI } from '../../../bootstrap/init';

export abstract class BaseActionPanelAPI implements IActionPanelAPI {
  abstract getContent(): React.ReactElement | undefined;

  abstract getHostContext(props?: IVirtualManifestBuilderProps): Promise<{
    getHost(): Host;
  }>;

  protected constructor() {
    this.getContent = this.getContent.bind(this);
    this.getHostContext = this.getHostContext.bind(this);
  }

  getMinimizedContent() {
    return this.getContent();
  }

  /**
   * @deprecated use `getHostContext` instead
   */
  getHost = async (props?: IVirtualManifestBuilderProps) => {
    const hostContext = await this.getHostContext(props);
    return hostContext.getHost();
  };

  protected async getInfraSDKHostContext(
    params: {
      appDefinitionId?: string;
    } & IVirtualManifestBuilderProps,
  ) {
    const infra = await getPlatformInfraAPI();
    return infra.getSDKHostContext(params);
  }
}
